import {Deserializable} from '../deserializable';

import {LoaiKeHoach} from '../danhmuc/loaikehoach';

import {KeHoachFile} from './kehoachfile';


export  class KeHoach implements Deserializable
{
  public  id: number;
  public  loaiKH: number;
  public  tenKH: string;
  public  noiDungKH: string;
  public  ghiChu: string;
  public  nguoiNhap: number;
  public  phoCap: number;
  public  soVanThuID: number;
  public loaiKeHoach: LoaiKeHoach;
  public  keHoachFiles: KeHoachFile[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.loaiKeHoach = input.loaiKeHoach != null ? new LoaiKeHoach().deserialize(input.loaiKeHoach): null;
    this.keHoachFiles = input.keHoachFiles != null ? input.keHoachFiles.map(keHoachFiles => new KeHoachFile().deserialize(keHoachFiles)): [];
    return this;
  }
}
